import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import EstimateForm from "src/components/as/EstimateForm";
import styled from "styled-components";
import AddEstimateItem from "src/components/as/AddEstimateItem";
import { useAsDetailQuery } from "src/api/asAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { initSheet, setAddSheet, setAPISheetAdd } from "src/store/reducers/estimateReduce";
import { useEstimateDetailQuery } from "src/api/estimateAPI";
import RejectionReason from "src/components/as/RejectionReason";
import { EstimateGoods } from "src/vo/estimateVo";
import { isEmpty } from "lodash";
import { addCommas } from "src/utils/addCommas";

interface initial {
  add: boolean;
  total_price?: number;
  apiSkip?: boolean;
  es_idx?: number;
  rerender: boolean;
  reRegister: boolean;
  cancelReason?: string;
}

const estimateRegister = () => {
  const navigate = useNavigate();
  const [init, setInit] = useState<initial>({
    add: false,
    total_price: 0,
    rerender: false,
    es_idx: 0,
    apiSkip: true,
    reRegister: false,
    cancelReason: "",
  });

  const { add, total_price, apiSkip, es_idx, rerender, reRegister, cancelReason } = init;

  // 지정한 업체만 등록 가능
  const index: any = getPathValue();
  const asDetail = useAsDetailQuery(index, { skip: false });
  const estimateDetail = useEstimateDetailQuery(es_idx, { skip: apiSkip });

  const estimateGoods: EstimateGoods = useAppSelector((state) => state.estimateReduce.estimate_goods);
  // 담긴 품명을 클릭했을때의 값
  const clickEstimateGoods = useAppSelector((state) => state.estimateReduce.estimate_goods_update);

  const dispatch = useAppDispatch();

  const addSheet = () => {
    if (estimateGoods.goods_name === "undefined" || estimateGoods.goods_name === undefined || estimateGoods.goods_name === "") {
      alert("'품명'을 입력해 주세요");
      return;
    }
    if (estimateGoods.spec === "undefined" || estimateGoods.spec === undefined || estimateGoods.spec === "") {
      alert("'단위'를 입력해 주세요");
      return;
    }
    if (String(estimateGoods.unit_price) === "undefined" || String(estimateGoods.unit_price) === undefined || estimateGoods.unit_price === 0) {
      alert("'단가'를 입력해 주세요");
      return;
    }
    if (String(estimateGoods.qty) === "undefined" || String(estimateGoods.qty) === undefined || estimateGoods.qty === 0) {
      alert("'수량'을 입력해 주세요");
      return;
    }
    dispatch(setAddSheet(estimateGoods));
    setInit({ ...init, add: add ? false : true, total_price: 0 });
  };

  useEffect(() => {
    // history.pushState(null, "", location.href);
    // window.onpopstate = function (event) {
    //   if (!confirm("뒤로가시겠습니까?")) {
    //     history.go(1);
    //   }
    // };
    dispatch(initSheet());
  }, []);

  useEffect(() => {
    //
  }, [history]);

  useEffect(() => {
    if (asDetail.isSuccess) {
      setInit({
        ...init,
        es_idx: asDetail.data.es_idx,
        apiSkip: false,
      });
    }
  }, [asDetail]);

  useEffect(() => {
    if (estimateDetail.isSuccess) {
      if (estimateDetail.data.estimateGoods.length > 0) {
        setInit({
          ...init,
          reRegister: true,
          cancelReason: estimateDetail.data.cancel_reason,
        });
      }
      dispatch(setAPISheetAdd(estimateDetail.data.estimateGoods));
    }
  }, [estimateDetail]);

  useEffect(() => {
    setInit({
      ...init,
      total_price: estimateGoods.total_price,
    });
  }, [estimateGoods]);

  useEffect(() => {
    setInit({
      ...init,
      add: !add,
    });
  }, [clickEstimateGoods]);

  const historyBackClick = () => {
    if (confirm("작성 내용이 삭제됩니다. 뒤로 가시겠습니까?")) {
      navigate(-1);
    }
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => historyBackClick()}>
            {reRegister ? "견적서 재등록" : "견적서 등록"}
          </Button>
        </div>
      </header>

      <Body type="detail">
        {reRegister && !isEmpty(cancelReason) ? <RejectionReason readonly={true} value={cancelReason} /> : ""}
        <RegisterWrap>
          <Box pd="25px 45px 30px">
            <EstimateForm />

            <SummaryBox>
              <p>
                = <span>{addCommas(total_price)}</span> 원
              </p>
            </SummaryBox>

            <Box pd="20px 0 0">
              <Button variant="contained" br="round" color="secondary" onClick={() => addSheet()}>
                담기
              </Button>
            </Box>
          </Box>

          <BottomFlex>
            <AddEstimateItem add={add} reRegister={reRegister} />
          </BottomFlex>
        </RegisterWrap>
      </Body>
    </>
  );
};

const RegisterWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")}
  height: auto;
  min-height: 100%;
  > div:last-child {
    flex: 1 0 auto;
  }
`;

const SummaryBox = styled.div`
  margin-top: 20px;
  ${({ theme }) => theme.flexBox.flexMixin()}
  > p {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    &:last-child {
      text-align: right;
      font-family: "Poppins";
      font-weight: 700;
      color: ${({ theme }) => theme.color.main};
    }
  }
`;

const BottomFlex = styled.div`
  padding: 20px 15px;
  border-top: 2px dashed #aaa;
  background-color: ${({ theme }) => theme.color.bgPrimary};
`;

export default estimateRegister;
